import { render, staticRenderFns } from "./wdIndustry.vue?vue&type=template&id=64bd120b"
import script from "./wdIndustry.vue?vue&type=script&lang=js"
export * from "./wdIndustry.vue?vue&type=script&lang=js"
import style0 from "./wdIndustry.vue?vue&type=style&index=0&id=64bd120b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports